var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
export const LoadingDialog = (_a) => {
    var { title, content, open = false } = _a, rest = __rest(_a, ["title", "content", "open"]);
    const classes = useStyles(rest);
    return (React.createElement(Dialog, Object.assign({ maxWidth: "xs", "aria-labelledby": "message-dialog-title", open: open }, rest),
        React.createElement(DialogTitle, { id: "message-dialog-title" }, title),
        React.createElement(DialogContent, { className: classes.root },
            React.createElement(Typography, { variant: "body1" }, content),
            React.createElement(CircularProgress, { className: classes.progress }))));
};
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    progress: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}), {
    name: 'Layer7LoadingDialog',
});
//# sourceMappingURL=LoadingDialog.js.map